import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-datenschutzerklaerung',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  templateUrl: './datenschutzerklaerung.component.html',
  styleUrls: ['./datenschutzerklaerung.component.css']
})
export class DatenschutzerklaerungComponent {}
